import React from "react";
import { IonSlides, IonSlide, IonImg, IonLabel } from "@ionic/react";

interface SlideProps {
  slideArray: Array<any>;
}

export const HorizontalSlides: React.FC<SlideProps> = ({ slideArray }: SlideProps) => {
  const bannerSlides = React.useRef<HTMLIonSlidesElement>(null);
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    let timeout: any;
    if (bannerSlides !== null) {
      timeout = setTimeout(() => {
        setShow(true);
        bannerSlides.current?.update();
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [bannerSlides]);
  return (
    <IonSlides
      pager={true}
      hidden={false}
      options={{
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        scrollbar: false,
        speed: 400,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          bulletActiveClass: "swiper-pagination-bullet-active",
          renderBullet: function (index: any, className: any) {
            return '<span class="swiper-pagination-bullet">' + "</span>";
          },
        },
      }}
    >
      {slideArray.map((ele, ind) => (
        <IonSlide key={ind}>
          <div className="login5" style={{ marginTop: 40 }}>
            <img src={ele.image} className="sliderImages" />
            <IonLabel className="login7" color="secondary">
              {ele.label1}
            </IonLabel>
            <IonLabel className="login8 capitalize" class="item-text-wrap" text-wrap>
              {ele.label2}
            </IonLabel>
          </div>
        </IonSlide>
      ))}
    </IonSlides>
  );
};
